const schemas = {
  betchan: (data) => {
    const birthdate = data.user.birthdate
    let year, month, day
    if (birthdate) {
      year = birthdate && birthdate.getFullYear()
      month = birthdate && birthdate.getMonth() + 1
      day = birthdate && birthdate.getDate()
    }

    return {
      // Credentials
      email: data.credentials.email,
      password: data.credentials.password,
      // password_confirmation: data.credentials.password,
      // User data
      first_name: data.user.firstName,
      last_name: data.user.lastName,
      date_of_birth: birthdate && year && month && day ? `${year}-${month}-${day}` : '',
      country: data.user.country,
      city: data.user.city,
      address: data.user.streetName + ' ' + data.user.houseNumber,
      postal_code: data.user.postalCode,
      currency: data.user.currency,
      mobile_phone: data.user.phoneE164,
      // GDPR
      terms_acceptance: (data.consent.terms && data.consent.terms.consent &&
        data.consent.privacy && data.consent.privacy.consent) || false,
      age_acceptance: (data.consent.age && data.consent.age.consent) || false,
      receive_promos: (data.consent.offers_email && data.consent.offers_email.consent) || false,
      receive_sms_promos: (data.consent.offers_sms && data.consent.offers_sms.consent) || false
    }
  },

  EveryMatrix: (data) => ({
    // Credentials
    email: data.credentials.email,
    username: data.credentials.username,
    alias: data.credentials.alias,
    password: data.credentials.password,
    confirm: data.credentials.password,
    passwordRepeat: data.credentials.password,
    // User data
    birthDate: data.user.birthday && data.user.birthday.toISOString().split('T')[0],
    dob: data.user.birthday && data.user.birthday.toISOString().split('T')[0],
    postalCode: data.user.postalCode,
    country: data.user.country,
    region: data.user.province,
    city: data.user.city,
    address1: data.user.houseNumber + ' ' + data.user.streetName,
    phone: data.user.phone,
    mobile: data.user.mobile,
    currency: data.user.currency,
    // GDPR
    acceptNewsEmail: (data.consent.offer_email && data.consent.offer_email.consent) || false,
    acceptSMSOffer: (data.consent.offer_sms && data.consent.offer_sms.consent) || false
  }),

  GIG: (data) => {
    const birthdate = data.user.birthdate
    return {
      // Credentials
      email: data.credentials.email,
      username: data.credentials.username,
      password: data.credentials.password,
      repeatPassword: data.credentials.password,
      // User data
      birth: birthdate && birthdate.toISOString().split('T')[0],
      ddlDay: birthdate && birthdate.getDate(),
      ddlMonth: birthdate && birthdate.getMonth() + 1,
      ddlYear: birthdate && birthdate.getFullYear(),
      title: data.user.title,
      firstname: data.user.firstName,
      surname: data.user.lastName,
      currency: data.user.currency,
      securityQuestion: data.user.securityQuestion,
      securityAnswer: data.user.securityAnswer,
      postalCode: data.user.postalCode,
      country: data.user.country,
      city: data.user.city,
      address1: data.user.houseNumber + ' ' + data.user.streetName,
      phone: data.user.phoneWithoutPrefix,
      phonePrefix: data.user.phonePrefix,
      mobile: data.user.phoneWithoutPrefix,
      mobilePrefix: data.user.phonePrefix,
      // GDPR
      consent_termsandconditions: data.consent.terms ? 'yes' : 'no',
      consent_emailmarketing: data.consent.offer_email ? 'yes' : 'no',
      consent_sms: data.consent.offer_sms ? 'yes' : 'no',
      consent_3rdparty: data.consent.thirdparty ? 'yes' : 'no',
      acceptTermsConditions: (data.consent.terms && data.consent.terms.consent) || false,
      allowNewsEmail: (data.consent.offer_email && data.consent.offer_email.consent) || false,
      allowSmsOffer: (data.consent.offer_sms && data.consent.offer_sms.consent) || false
    }
  }
}

const transformData = (data, schema) => schemas[schema](data)

export default transformData



// WEBPACK FOOTER //
// ./src/utils/data-transfrom.js